export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wenn Sie den Handel abbrechen, wird er ohne Abschluss der Operation geschlossen."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sind Sie sicher, dass Sie den Handel abbrechen möchten?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja, abbrechen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nein, aktiv lassen"])}
}